import { IThongKeSoLuongSinhVienRequest } from "../../model/request/bao-cao/IThongKeSoLuongSinhVienRequest";
import { apiClient } from "../apiClient";

const ENDPOINT = "thong-ke-so-luong-sinh-vien";

export const thongKeSoLuongSinhVienApi = {
  Select: (request: IThongKeSoLuongSinhVienRequest) =>
    apiClient.post(`${ENDPOINT}/select`, request),
  ExportExcel: (request: IThongKeSoLuongSinhVienRequest) =>
    apiClient.post(`${ENDPOINT}/export-excel`, request),
  /** Bản xem trước (HTML dựng từ chính tệp Excel sẽ xuất) — dùng để in. */
  XemTruoc: (request: IThongKeSoLuongSinhVienRequest) =>
    apiClient.post(`${ENDPOINT}/xem-truoc`, request),
};
